import { useContext } from 'react'

import { WebApiContextValue } from '../types/web-api.types'
import { WebApiContext } from '../services/web-api'

export function useWebApi(): WebApiContextValue {
  return useContext(WebApiContext)
}
